import React, { useState } from 'react';
import 'App.css';
import { connect } from 'react-redux';
import { Sidebar, Menu, Icon } from 'semantic-ui-react';
import IconView from 'common/IconView';
import AppAbout from 'AppAbout';
import AppMenuNew from 'AppMenuNew';
import Blueprints from 'Blueprints';
import OpenModuleDialog from 'OpenModuleDialog';
import { newModule } from 'events/module';
import BlueprintEditor from 'editors/BlueprintEditor';
import { exportXML } from 'io/export';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';

const App = function(props) {

  const [ showSidebar, setSidebarShown ] = useState(false);
  const [ aboutVisible, setAboutShown ] = useState(false);
  const [ selectedBlueprint, setSelectedBlueprint ] = useState(null);
  const [ openVisible, setOpenShown ] = useState(false);

  const openPusher = function() { setSidebarShown(true); }
  const closePusher = function() { setSidebarShown(false); }
  const showAbout = function() { setAboutShown(true); }
  const hideAbout = function() { setAboutShown(false); }

  const mod = props.module;

  const onSelectBlueprint = (bp) => {
    setSelectedBlueprint(bp.ID);
  };

  const openModule = function() {
    closePusher();
    setOpenShown(true);
  }

  const saveModule = function() {
    const xml = exportXML(mod, new XMLSerializer());
    const zip = new JSZip();
    for (let [key, value] of Object.entries(xml)) {
      const name = key;
      zip.file(name, value);
    }
    zip.generateAsync({type:'blob'}).then(function(blob) {
      saveAs(blob, "module.zip");
    });
  }

  return (
    <React.Fragment>
      <Sidebar.Pushable>
        <Sidebar visible={showSidebar}
                 as={Menu}
                 inverted
                 vertical
                 animation='overlay'
                 width='thin'
                 onHide={closePusher}
                 icon='labeled'
                 size='tiny'
                 >
          <Menu.Item onClick={closePusher}>
            <Icon name='bars' />
            Close
          </Menu.Item>
          <Menu.Item onClick={() => { props.newModule(); closePusher(); }}>
            <Icon name='file' />
            New module
          </Menu.Item>
          <Menu.Item onClick={openModule}>
            <Icon name='upload' />
            Open module
          </Menu.Item>
          <Menu.Item onClick={saveModule}>
            <Icon name='download' />
            Save module
          </Menu.Item>
          <Menu.Item onClick={() => {showAbout(); closePusher();}}>
            <Icon name='info circle' />
            About
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={showSidebar}>
          <Menu inverted>
            <Menu.Item onClick={openPusher}>
              <Icon name='bars' />
            </Menu.Item>
            <AppMenuNew />
            <Menu.Item><IconView icon={mod.Icon}/>{mod.Name} [{mod.ID}]</Menu.Item>
          </Menu>
          <div className='editor'>
            <Blueprints vertical
                        className='editor-list'
                        blueprints={mod.Blueprints}
                        selected={selectedBlueprint}
                        onSelectBlueprint={onSelectBlueprint} />
            <BlueprintEditor className='editor-pane'
                             id={selectedBlueprint}
                             onSelectBlueprint={onSelectBlueprint} />
          </div>
        </Sidebar.Pusher>
      </Sidebar.Pushable>

      <AppAbout visible={aboutVisible} onClose={hideAbout} />

      <OpenModuleDialog visible={openVisible} onClose={() => setOpenShown(false)} />

    </React.Fragment>
  );
}

const mapState = function(state) {
  return {
    module: state.module
  }
}

const mapDispatch = function(dispatch) {
  return {
    newModule: () => dispatch(newModule())
  }
}

const TheApp = connect(mapState, mapDispatch)(App);

export default TheApp;
